import * as BridgeEvents from '@/common/bridge/modern-bridge/bridge-events';

import type { PleasedChatCloseReason } from '@/pleased-sdk/PleasedChat/PleasedChat.types';

/** Idle timeout after which `on_chat:end` is emitted while the chat session stays open. */
export const CHAT_IDLE_END_MS = 30 * 60 * 1000;

export function createChatSessionHostEvents() {
  let idleTimer: ReturnType<typeof setTimeout> | null = null;
  let hasEmittedEnd = false;

  const clearIdleTimer = (): void => {
    if (idleTimer === null) {
      return;
    }

    clearTimeout(idleTimer);
    idleTimer = null;
  };

  const emitChatEndOnce = (): void => {
    if (hasEmittedEnd) {
      return;
    }

    hasEmittedEnd = true;
    BridgeEvents.emitChatEnd();
  };

  const scheduleIdleEnd = (): void => {
    if (hasEmittedEnd) {
      return;
    }

    clearIdleTimer();
    idleTimer = setTimeout(() => {
      idleTimer = null;
      emitChatEndOnce();
    }, CHAT_IDLE_END_MS);
  };

  const handleStarted = (): void => {
    hasEmittedEnd = false;
    BridgeEvents.emitChatStart();
    scheduleIdleEnd();
  };

  const handleUserActivity = (): void => {
    scheduleIdleEnd();
  };

  const handleClosed = (reason: PleasedChatCloseReason): void => {
    clearIdleTimer();

    if (reason === 'local') {
      emitChatEndOnce();
    }
  };

  const dispose = (): void => {
    clearIdleTimer();
  };

  return {
    handleStarted,
    handleUserActivity,
    handleClosed,
    dispose,
  };
}
